<template>
  <div class="zone" v-loading="loading" :element-loading-text="loadingText">
    <functionBox  :titleData="{permission_flag:'SparePart',nowID:1}"
                  @searchBtn="searchBtn" @addCheck="editCheck('1')" :hideSearchBtn = true  @clearSearch="clearSearch" :searhLoading="loading">
      <template>
        <li>
          <el-input placeholder="请输入关键字" v-model="searchParams.keywords" clearable size="small"></el-input>
        </li>

        <li>
          <el-input placeholder="请输入完整DI码" v-model="searchParams.di" clearable size="small"></el-input>
        </li>
        <li>
          <el-button type="primary" size="mini"  @click="searchBtn">查找</el-button>
          <el-button type="info" size="mini" @click="clearSearch">重置</el-button>
        </li>
        <div  class="right" style="margin-top: 10px;text-align: right;width: 43%">
          <el-button type="primary" size="mini"  @click="handleImport"   style="text-align: right; background: #54BCBD;border:#54BCBD">导入DI码</el-button>
          <el-button type="primary" size="mini" @click="handleExport"   style="text-align: right; background: #1acb64;border:#1acb64">全部导出</el-button>
        </div>
      </template>
    </functionBox>
    <div class="sheet"  v-loading="loading" :element-loading-text="loadingText">
      <el-table :data="tableData" stripe  :height="tableSize== 'big' ? '960' : tableSize== 'middle' ?'630' : '430'">
        <el-table-column type="index" width="55" label="序号"  align="center"> </el-table-column>
        <el-table-column prop="di" label="DI码" min-width="220" align="center">
          <template v-slot="{row}">
            <span style="color:#4095E5;border-bottom:1px solid #4095E5;cursor: pointer" @click="handleCheck(row)">{{row.di}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reagent_name" label="产品名称"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="erp_id" label="对应ERP编码"  min-width="150" align="center">
          <template v-slot="{row}">
            <span style="color:#4095E5;border-bottom:1px solid #4095E5;cursor: pointer"  @click="handleCheck(row)">{{row.erp_id}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="standard" label="包装规格"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="product_categories" label="产品分类"  min-width="150" align="center"></el-table-column>
        <el-table-column prop="brand_name" label="品牌名称"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="rfid" label="RFID标识"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="rfid_remarks" label="RFID标识备注"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="commodity" label="医疗器械或药品注册证编号"  min-width="200" align="center"></el-table-column>
        <el-table-column prop="reagent_keywords" label="关键字"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="note" label="备注"  min-width="120" align="center"></el-table-column>
      </el-table>
      <div class="el_pagination_style">
        <el-pagination
            :hide-on-single-page="total <= 0"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageParams.size"
            :current-page.sync="pageParams.page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>

      <el-dialog
          title="查看信息"
          v-if="checkDialog"
          :visible.sync="checkDialog"
          width="70%"
          custom-class="checkDialog"
          @closed="handleClose1"
      >
        <check-dialog ref="checkDialog"  v-if="checkDialog" :formData="formData" ></check-dialog>
        <span slot="footer" class="dialog-footer" style="text-align: center">
           <el-button type="primary" @click="checkDialog=false">关闭页面</el-button>
        </span>
      </el-dialog>
      <el-dialog
          class="importDialog"
          title="导入DI码"
          :visible.sync="importDialog"
          width="60%"
          :before-close="handleClose">
        <import-dialog  v-if="importDialog" ></import-dialog>
        <span slot="footer" class="dialog-footer" style="text-align: center">
           <el-button type="primary" @click="handleConfirmSave()">导入完成&关闭弹窗</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TJDetailTitle from '@/components/TJDetailTitle'
import FunctionBox from '@/views/Statistics/components/functionBox.vue'
import {addMenu, getAssetMgtBtn} from "@/router/menuMain";
import checkDialog from "@/views/Other/DICode/components/checkDialog.vue"
import importDialog from "@/views/Other/DICode/components/importDialog.vue"

import apiDetail from '@/api/other.js'
export default {
  components: {TJDetailTitle, checkDialog, FunctionBox,importDialog},
  name: 'DICode',  // DI管理列表
  data() {
    return {
      dialogType_dept: '1',
      userRoleId: JSON.parse(localStorage.getItem('userInfo')).org_post,
      checkDialog: false,
      importDialog: false,
      tableSize: '',
      user_id: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false, //加载动画
      tableData: [],
      check_time: [],
      tableHeight: 0,
      searchType: '0',
      message: '',
      searchParams:{
        keywords: '',
        di: '',
      },
      pageParams:{
        page: 1,
        size: 10,
      },
      loadingText: '数据加载中，请稍后',
      formData: {},
      showData:false,
    }
  },
  created() {
    this.getTableHeight()
    let menuList = JSON.parse(localStorage.getItem('menuList'))
    addMenu(menuList);
    this.getList()
    this.user_id = JSON.parse(localStorage.getItem("userInfo")).user_id
    if(window.innerWidth<1550){
      this.tableSize = 'small'
    }else if(window.innerWidth < 2400 && window.innerWidth > 1550){
      this.tableSize = 'middle'
    }else{
      this.tableSize = 'big'
    }
  },
  methods: {
    handleExport(){
      let params = {
        ...this.searchParams,
        page:  this.pageParams.page,
        size: this.pageParams.size,
        export:1
      }
      apiDetail.getDIListInfo(params).then(res=>{
        if(res.data){
          this.downloadFile(res.data)
        }

      })
    },
    downloadFile(url) {
      return new Promise((resolve, reject) => {
        const fileName = url.split('/').pop()
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = fileName
        // 这个延迟操作的目的是为了确保浏览器有足够的时间来处理下载操作
        // 这样可以避免在循环中快速触发多个下载操作，导致浏览器无法正确处理下载请求
        link.addEventListener('click', () => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
        link.click()
      }).finally(()=>{this.exporting = false})
    },
    getTableHeight(){
      var viewportHeight = window.innerHeight;
      var viewportWidth =  window.innerWidth
      // var element = document.getElementById('pagination');
      if(viewportWidth > 2400){
        this.tableHeight = viewportHeight - 500
      }else if(viewportWidth < 2400 &&  viewportWidth > 1550){
        this.tableHeight = viewportHeight - 400
      }else{
        this.tableHeight = viewportHeight - 600
      }
    },
    getList(){
      this.loading = true
      this.loadingText = '数据加载中，请稍后'


      let params = {
        ...this.searchParams,
        page:  this.pageParams.page,
        size: this.pageParams.size
      }
      apiDetail.getDIListInfo(params).then(res=>{
        this.total = res.data.count
        this.tableData = res.data.data
        this.loading = false
      }).catch(err =>{
        this.loading = false
        if( err.status === 'error' && this.searchParams.page >1 ){
          this.searchParams.page--
          this.getList()
        }
      })
    },

    searchBtn() {  // 搜索
      this.pageParams.page = 1
      if(this.check_time){
      }else{
        this.searchParams.start_time = ''
        this.searchParams.end_time = ''
      }
      this.searchType = '1'
      this.getList();
    },
    handleCurrentChange(val) { // 翻页
      this.page = val
      this.getList('1')
    },
    clearSearch(){  // 重置
      this.pageParams.page = 1
      this.searchParams.keywords =  ''
      this.searchParams.di = ''
      this.getList('1');

    },

    handleSizeChange(val){
      this.pageParams.size = val

      this.getList('1');
    },
    handleCheck(row){
      this.checkDialog = true;
      this.formData = { ...row }; // 使用解构避免引用问题（可选）
    },
    handleImport(){
      this.importDialog = true
    },
    handleEdit(row){
    },
    handleConfirmSave(){
      this.importDialog = false
      this.getList()

    },
    handleClose1(){
      this.checkDialog = false
    },
    handleClose(){
      this.importDialog = false
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/asset';
::v-deep .el-table th:first-child.el-table__cell>.cell{
  padding-left:14px!important;
}
::v-deep .el-pagination__sizes{
  width: 80px;
  vertical-align: top;
}
::v-deep .el-pagination__sizes .el-select{
  vertical-align: top;
}
::v-deep .el-pagination__sizes input{
  width: 80px;
  height: 1.8rem;
  border: 1px solid #999999;
}
::v-deep .el-pagination .el-input__suffix{
  right: 22px;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 0.75rem!important;
}
::v-deep .el-dialog__footer{
  text-align: center;
}
::v-deep .el-dialog__header{
  margin: 0 20px;
  border-bottom: 1px solid #eee;
}
.addDialog{
  ::v-deep .el-dialog__body{
    padding: 0 80px!important;
  }
}
.importDialog {
  display: flex;
  padding: 20px;
  ::v-deep .el-dialog { margin: auto !important; }
}
</style>
